import { COUNTRY_CODE, bizmatesSiteBaseUrl, ZIPAN_SITE_URL } from '@/utils/constants';
import store from '@/store/index';

export const isZipanHost = window.location.hostname.includes('zipan.jp');

const isZipanStg = window.location.hostname.includes('.stag.zipan.jp');
const isZipanProd = window.location.hostname === "mystage.zipan.jp";

/*
 * Returns the appropriate student/trainers home page based on the current hostname and country ID
 * Global - bizmates.global/<country code>
 * Zipan - zipan.jp
 * Bizmates JP - bizmates.jp
 */
export function getHomeUrl(countryId = null) {
  let homeUrl = '/MyBizmates/home';

  if (isZipanHost && !isZipanStg && !isZipanProd) {
    homeUrl = '/MyZipan/home';
  }

  return getParentSiteUrl(countryId) + homeUrl;
}

/*
 * Returns the appropriate student/trainers portal URL based on the current hostname and country ID
 * Global - bizmates.global/<country code>
 * Zipan - zipan.jp
 * Bizmates JP - bizmates.jp
 */
export function getParentSiteUrl(countryId = null, accType = null) {
  const host = window.location.hostname;
  const globalUrl = process.env.VUE_APP_BIZMATES_GLOBAL_URL;
  
  // Add store accType value as fallback
  // Some part of MyStage has its own way to pass accType e.g. chat history
  accType = accType ?? store.state?.accType;
  // Only use timezone fallback if accType is not defined (no valid token)
  const isTrainer = accType ? (accType === 't') : isTrainerByTimezone();

  // GLOBAL SITE
  if (host.includes('bizmates.global') && !isTrainer) {
    const countryCode = COUNTRY_CODE[countryId] ?? 'tw';
    return `${globalUrl}/${countryCode}`;
  }
  
  // ZIPAN
  if (isZipanHost) {
    return ZIPAN_SITE_URL;
  }
  
  // DEFAULT (BIZMATES.JP)
  return bizmatesSiteBaseUrl;
}

/*
 * Returns the appropriate MBTI API base URL based on the current hostname
 * Global - VUE_APP_BIZMATES_TW_API_URL (Taiwan)
 * Zipan - VUE_APP_ZIPAN_API_URL
 * Bizmates JP - VUE_APP_BIZMATES_URL (default)
 */
export function getMbtiUrl() {
  const host = window.location.hostname;

  // ZIPAN
  if (isZipanHost) {
    return process.env.VUE_APP_ZIPAN_API_URL;
  }

  // GLOBAL SITE (Taiwan)
  if (host.includes('bizmates.global')) {
    return process.env.VUE_APP_BIZMATES_TW_API_URL;
  }

  // DEFAULT (BIZMATES.JP - Japan)
  return process.env.VUE_APP_BIZMATES_URL;
}


/**
 * Detects if the user is a trainer based on their local timezone.
 * Falls back to checking trainer timezones in TIMEZONE_COUNTRY_MAP_TRAINER.
 */
export function isTrainerByTimezone() {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return Object.keys(TIMEZONE_COUNTRY_MAP_TRAINER).some(zone =>
    tz === zone || tz.startsWith(zone)
  );
}

/**
 * Timezone → Country mappings (for reference)
 */
export const TIMEZONE_COUNTRY_MAP_TRAINER = {
  'Asia/Manila': 'Philippines',
  'Africa/Lagos': 'Nigeria',
  'America/New_York': 'USA',
  'America/Chicago': 'USA',
  'America/Denver': 'USA',
  'America/Los_Angeles': 'USA'
};

export const TIMEZONE_COUNTRY_MAP_STUDENT = {
  'Asia/Tokyo': 'Japan',
  'Asia/Taipei': 'Taiwan'
};
